import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateAiModelConfigMutationVariables = Types.Exact<{
  feature: Types.Scalars['String']['input'];
  provider: Types.Scalars['String']['input'];
  model_name: Types.Scalars['String']['input'];
  effort?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type UpdateAiModelConfigMutation = { __typename?: 'mutation_root', update_ai_model_config: { __typename?: 'AiModelOptionsResult', efforts: Array<string>, providers: Array<{ __typename?: 'AiProviderOption', provider: string, label: string, models: Array<{ __typename?: 'AiModelOption', id: string, label: string }> }>, features: Array<{ __typename?: 'AiFeatureModelConfig', feature: string, label: string, provider: string, model_name: string, effort?: string | null }> } };


export const UpdateAiModelConfigDocument = gql`
    mutation updateAiModelConfig($feature: String!, $provider: String!, $model_name: String!, $effort: String) {
  update_ai_model_config(
    feature: $feature
    provider: $provider
    model_name: $model_name
    effort: $effort
  ) {
    efforts
    providers {
      provider
      label
      models {
        id
        label
      }
    }
    features {
      feature
      label
      provider
      model_name
      effort
    }
  }
}
    `;
export type UpdateAiModelConfigMutationFn = Apollo.MutationFunction<UpdateAiModelConfigMutation, UpdateAiModelConfigMutationVariables>;

/**
 * __useUpdateAiModelConfigMutation__
 *
 * To run a mutation, you first call `useUpdateAiModelConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAiModelConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAiModelConfigMutation, { data, loading, error }] = useUpdateAiModelConfigMutation({
 *   variables: {
 *      feature: // value for 'feature'
 *      provider: // value for 'provider'
 *      model_name: // value for 'model_name'
 *      effort: // value for 'effort'
 *   },
 * });
 */
export function useUpdateAiModelConfigMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAiModelConfigMutation, UpdateAiModelConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAiModelConfigMutation, UpdateAiModelConfigMutationVariables>(UpdateAiModelConfigDocument, options);
      }
export type UpdateAiModelConfigMutationHookResult = ReturnType<typeof useUpdateAiModelConfigMutation>;
export type UpdateAiModelConfigMutationResult = Apollo.MutationResult<UpdateAiModelConfigMutation>;
export type UpdateAiModelConfigMutationOptions = Apollo.BaseMutationOptions<UpdateAiModelConfigMutation, UpdateAiModelConfigMutationVariables>;